import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable, Subject, tap} from 'rxjs';
import {toSignal} from '@angular/core/rxjs-interop';
import {APIRequest, APIRequestResources, PaginationResponse} from "../../../../../core";
import {
    CustomerGetDTO,
    CustomerGridDTO,
    CustomerUpdateDTO,
    UpdateExistingAddressDTO
} from '../interfaces/customer.entity';

@Injectable({
  providedIn: 'root'
})
export class CustomerManagementService extends APIRequest {
  private readonly $all = new BehaviorSubject<CustomerGridDTO[]>([]);
  all = toSignal(this.$all, { initialValue: [] });

  private readonly $active = new BehaviorSubject<CustomerGetDTO | undefined>(undefined);
  active = toSignal(this.$active, { initialValue: undefined });

  private customerCreated = new Subject<void>();

  constructor(protected override http: HttpClient) {
    super(http, APIRequestResources.CustomerService);
  }

  find(searchParams: any) {
    
    return this.get<PaginationResponse<CustomerGridDTO[]>>({
      endpoint: 'search',
      params: searchParams,
    }).pipe(
      tap((res) => this.$all.next(res.data.data))
    );
  }

  getById(id: any) {
    return this.get<CustomerGetDTO>({ id })
      .pipe(
        tap((res) => this.$active.next(res.data))
      );
  }

  create(customer: any) {
    return this.post<any>(customer, {});
  }
updateAddresses(customerId: number, payload: any) {
  const options = {
    endpoint: 'address',
    suffix: customerId.toString()
  };
  return this.post<any>(payload, options);
}


updateExistingAddress(addressId: number, payload: UpdateExistingAddressDTO) {
  const options = {
    endpoint: 'address/update',
    suffix: addressId.toString()
  };
  return this.patch<any>(payload, options);
}


  updateContactPersons(payload: any) {
    return this.post<any>(payload, {});
  }

  update(customer: Partial<CustomerUpdateDTO>) {
    const options = {};
    return this.patch<any>(customer, options);
  }

    toggleCustomerStatus(customerId: number, isActive: number, updatedBy: string) {
    const payload = { isActive, updatedBy };
    const options = { 
      endpoint: 'active',
      suffix: customerId.toString() 
    };
    return this.patch<any>(payload, options);
  }


  checkCustomerCodeExists(customerCode: string, customerId?: number) {
    return this.get<any>({
      endpoint: 'exist',
      params: { 
        customer_code: customerCode,
        customer_id: customerId || -1
      },
    });
  }

  notifyCustomerCreated() {
    this.customerCreated.next();
  }

  onCustomerCreated(): Observable<void> {
    return this.customerCreated.asObservable();
  }

  initial() {
    this.$active.next(undefined);
  }

      toggleAddressStatus(addressId: any, payload: any) {
    const options = { 
      endpoint: 'address/active',
      suffix: addressId.toString() 
    };
    return this.patch<any>(payload, options);
  }
  
}